import React from 'react';
import styled from 'styled-components';
import image1 from '../../../Assets/davie-agencies 2.png';
import image2 from '../../../Assets/smart-help.png';
import { StyledButton } from '../../../Components/Generics.styled';
import image3 from '../../../Assets/daviedealsapp-2.png';
import { useHistory } from 'react-router-dom';

const AgencyMeetDavieContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 1400px;
    align-items: center;
`;

const TitleContainer = styled.div`
    align-items: center;
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    font-size: 46px;
`;
const SubTitleContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 26px;
`;

const SectionOneContainer = styled.div`
    display: flex;

    width: 1200px;
    justify-content: space-between;
    height: 600px;
    margin-top: 30px;
`;

const SectionOneCol1 = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    font-size: 19px;
`;

const SectionOneCol1Row1 = styled.div`
    height: 180px;
`;
const SectionOneCol1Row2 = styled.div`
    height: 180px;
`;

const SectionOneCol2 = styled.div`
    width: 100%;
`;
const SectionOneCol3 = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    font-size: 19px;
`;

const SectionOneCol3Row1 = styled.div`
    height: 180px;
`;
const SectionOneCol3Row2 = styled.div`
    height: 180px;
`;

const Image1Container = styled.div`
    height: 100%;
    width: 100%;
`;
const Image1 = styled.img`
    object-fit: contain;
    height: 100%;
    width: 100%;
`;

const SectionTwoContainer = styled.div`
    display: flex;

    width: 1200px;
    justify-content: space-between;
    height: 500px;
    margin-top: 100px;
`;

const SectionTwoCol1 = styled.div`
    width: 60%;
`;
const SectionTwoCol2 = styled.div`
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Image2Container = styled.div`
    height: 320px;
    width: 320px;
`;
const Image2 = styled.img`
    object-fit: contain;
    height: 100%;
    width: 100%;
`;

const SectionTwoTitle = styled.div`
    font-size: 46px;

    width: 600px;
`;

const SectionTwoText = styled.div`
    font-size: 19px;
    width: 650px;
    margin-top: 30px;
`;

const SectionThreeContainer = styled.div`
    width: 100vw;
    height: 500px;
    background-color: #f4f4f1;
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const SectionThreeSubContainer = styled.div`
    display: flex;
    width: 900px;
    height: 300px;
`;

const SectionThreeColumn1 = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const SectionThreeColumn2 = styled.div`
    font-size: 19px;
    display: flex;

    width: 100%;
    justify-content: center;
    align-items: center;
`;

const SectionFourContainer = styled.div`
    width: 1200px;
    display: flex;
    height: 680px;
    margin-top: 100px;
    justify-content: center;
`;

const SectionFourCol1 = styled.div`
    width: 100%;
    background-color: #ef8b69;
    padding: 30px;
    color: white;
    font-size: 19px;
`;
const SectionFourCol2 = styled.div`
    width: 100%;
    background-color: #3366ff;
    padding: 30px;
    color: white;
    font-size: 19px;
`;
const Section4Title = styled.div`
    margin-bottom: 30px;
    font-size: 46px;
    color: white;
    text-align: center;
`;

const SectionFiveContainer = styled.div`
    width: 1200px;
    display: flex;
    height: 350px;
    margin-top: 100px;
    justify-content: center;
`;

const SectionFiveCol1 = styled.div`
    width: 100%;
    background-color: #3366ff;
    padding: 30px;
    color: white;
    font-size: 19px;
`;
const SectionFiveCol2 = styled.div`
    width: 100%;
    padding: 30px;
    color: white;
    font-size: 19px;
`;

const Section5Title = styled.div`
    margin-bottom: 30px;
    font-size: 46px;
    color: white;
    text-align: center;
`;

const Image3Container = styled.div`
    height: 100%;
    width: 100%;
`;
const Image3 = styled.img`
    object-fit: contain;
    height: 100%;
    width: 100%;
`;

const SectionSixContainer = styled.div`
    width: 1200px;
    display: flex;
    height: 250px;
    margin-top: 100px;
    justify-content: center;
`;

const SectionSixCol1 = styled.div`
    display: flex;
    width: 100%;
    background-color: #ef8b69;
    padding: 30px;
    color: white;
    font-size: 19px;
    align-items: center;
    justify-content: center;
`;
const SectionSixCol2 = styled.div`
    background-color: #3366ff;
    width: 100%;
    padding: 30px;
    color: white;
    font-size: 19px;
`;

const Section6Title = styled.div`
    font-size: 46px;
    width: 400px;
    line-height: 50px;
    color: white;
    text-align: center;
`;

const Section7Container = styled.div`
    margin-top: 50px;
`;

const AgencyMeetDavie = () => {
    const history = useHistory();

    const routeToTeach = () => {
        history.push('/portal/teach/learn');
    };
    return (
        <AgencyMeetDavieContainer>
            <TitleContainer>davie.ai for Agencies & Advertising Pros</TitleContainer>
            <SubTitleContainer>Accelerate your digital marketing workflow</SubTitleContainer>
            <SectionOneContainer>
                <SectionOneCol1>
                    <SectionOneCol1Row1>
                        <span style={{ color: '#3366ff' }}>davie</span>.<b>ai</b> is an
                        indispensable tool for agencies and advertising professionals including
                        in-house marketing departments, making digital advertising more efficient
                        and media placement easy.
                    </SectionOneCol1Row1>
                    <SectionOneCol1Row2>
                        <span style={{ color: '#3366ff' }}>davie</span>.<b>ai</b> combines open and
                        proprietary AI tools to recommend campaign strategies, suggest messaging and
                        create digital media campaigns
                    </SectionOneCol1Row2>
                </SectionOneCol1>
                <SectionOneCol2>
                    <Image1Container>
                        <Image1 alt="davie-agency" src={image1} />
                    </Image1Container>
                </SectionOneCol2>
                <SectionOneCol3>
                    <SectionOneCol3Row1>
                        <span style={{ color: '#3366ff' }}>davie</span> provides direct access to
                        hundreds of programmatic ad exchanges, facilitates text, display, video,
                        audio, email, and social media ad placement. Do much more with so much less
                        time required to do them!
                    </SectionOneCol3Row1>
                    <SectionOneCol3Row2>
                        With <span style={{ color: '#3366ff' }}>davie</span>.<b>ai</b>, there is no
                        minimum monthly spend requirement, and depending on your budget you can
                        reduce media costs and DSP fees and commissions.
                    </SectionOneCol3Row2>
                </SectionOneCol3>
            </SectionOneContainer>
            <SectionTwoContainer>
                <SectionTwoCol1>
                    <SectionTwoTitle>
                        Your <span style={{ color: '#3366ff', fontWeight: '600' }}>Smart</span>{' '}
                        Advertising Assistant
                    </SectionTwoTitle>
                    <SectionTwoText>
                        Imagine a very smart junior copywriter, a young and ambitious media buyer,
                        an active ad desk tech, and an accounting clerk that will work without ever
                        sleeping or taking a day off, to make your job easier. davie.ai makes
                        suggestions based on data that becomes more precise as you train him. Davie
                        learns with every transaction and gets feedback from DSP, Media, and users
                        building on AI and interactions to make campaigns increasingly effective.
                        davie works best with you collaborating and supervising to add the human
                        touch and emotional appeal to your ads and campaigns.
                    </SectionTwoText>
                </SectionTwoCol1>
                <SectionTwoCol2>
                    <Image2Container>
                        <Image2 alt="davie-agency" src={image2} />
                    </Image2Container>
                    <div style={{ fontSize: '26px' }}>Me time again!</div>
                </SectionTwoCol2>
            </SectionTwoContainer>
            <SectionThreeContainer>
                <SectionThreeSubContainer>
                    <SectionThreeColumn1>
                        <div style={{ fontSize: '46px' }}>
                            Use <span style={{ color: '#3366ff' }}>davie</span>.ai for:
                        </div>
                        <StyledButton
                            style={{
                                borderRadius: '44px',
                                width: '245px',
                                fontSize: '20px',
                                minHeight: '70px',
                            }}
                            variant="contained"
                            color="primary"
                            onClick={() => routeToTeach()}
                        >
                            Lets Get Started
                        </StyledButton>
                    </SectionThreeColumn1>
                    <SectionThreeColumn2>
                        <ol>
                            <li>Suggesting digital campaign strategy</li>
                            <li>Offering messaging suggestions</li>
                            <li>Drafting ads, headlines, copy</li>
                            <li>Recommending budgets and budget allocations</li>
                            <li>
                                Proposing campaign types and content making targeting suggestions
                            </li>
                        </ol>
                    </SectionThreeColumn2>
                </SectionThreeSubContainer>
            </SectionThreeContainer>
            <SectionFourContainer>
                <SectionFourCol1>
                    <Section4Title>How davie.ai works</Section4Title>
                    davie.ai works best when you start by providing some basic information about
                    your business, about each advertiser, identify your account owner and primary
                    liaison with davie. Once your sign-up, set-up your account, and start adding the
                    information for each advertiser for whom you’ll be creating campaigns. davie.ai
                    gathers information when you train davie.ai about each advertiser with some
                    basic information, including a website and description of their offering and
                    best customer. This is done by “Training davie.ai”. To train davie select your
                    advertiser, then click on Train davie.ai on your dashboard and answer a few
                    questions. davie.ai will combine the information that you provided with content
                    on the advertiser’s website and will quickly scan the Internet for similar
                    companies to make suggestions and create campaigns. davie.ai will start with
                    some digital marketing plan strategies, campaigns, targeting, and budgeting
                    suggestions. To maximize the benefit from davie.ai’s work, you should
                    collaborate to refine his drafts as you would for any assistant.
                </SectionFourCol1>
                <SectionFourCol2>
                    <Section4Title>Getting started</Section4Title>
                    davie.ai works best when you start by providing some basic information about
                    your business, about each advertiser, identify your account owner and primary
                    liaison with davie. Once your sign-up, set-up your account, and start adding the
                    information for each advertiser for whom you’ll be creating campaigns. davie.ai
                    gathers information when you train davie.ai about each advertiser with some
                    basic information, including a website and description of their offering and
                    best customer. This is done by “Training davie.ai”. To train davie select your
                    advertiser, then click on Train davie.ai on your dashboard and answer a few
                    questions. davie.ai will combine the information that you provided with content
                    on the advertiser’s website and will quickly scan the Internet for similar
                    companies to make suggestions and create campaigns. davie.ai will start with
                    some digital marketing plan strategies, campaigns, targeting, and budgeting
                    suggestions. To maximize the benefit from davie.ai’s work, you should
                    collaborate to refine his drafts as you would for any assistant.
                </SectionFourCol2>
            </SectionFourContainer>
            <SectionFiveContainer>
                <SectionFiveCol1>
                    <Section5Title>davie.ai&apos;s Affiliated Apps</Section5Title>
                    davie.ai has companion apps and websites that provide a precise targeting
                    opportunity for your advertisers. daviedeals, for example, allows davie.ai to
                    match merchants and consumers directly using a machine-learning technology that
                    allows users to curate their app to seek the
                </SectionFiveCol1>
                <SectionFiveCol2>
                    <Image3Container>
                        <Image3 alt="davie-agency" src={image3} />
                    </Image3Container>
                </SectionFiveCol2>
            </SectionFiveContainer>
            <SectionSixContainer>
                <SectionSixCol1>
                    <Section6Title>Generating more Revenue for Your Business</Section6Title>
                </SectionSixCol1>
                <SectionSixCol2>
                    Davie.ai is also poised to refer new clients to your agency as well. davie
                    refers users who need help from human advertising professionals, where machines
                    just aren’t enough! As your clients grow with davie’s help, they’ll also need
                    talent, experience, creativity, and humanity of advertising professionals who
                    together with davie, create an unbeatable competitive force.
                </SectionSixCol2>
            </SectionSixContainer>
            <Section7Container>
                <StyledButton
                    style={{
                        borderRadius: '44px',
                        width: '245px',
                        fontSize: '20px',
                        minHeight: '70px',
                    }}
                    variant="contained"
                    color="primary"
                    onClick={() => routeToTeach()}
                >
                    Lets Get Started
                </StyledButton>
            </Section7Container>
        </AgencyMeetDavieContainer>
    );
};

export default AgencyMeetDavie;
